import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import InputSearch from "../../../components/inputs/inputSearch/inputSearch";
import InputDropdown from "../../../components/inputs/inputDropdown/inputDropdown";
import Table from "../../../components/table/table";
import Notification from "../../../components/notification/notification";
import Button from "../../../components/button/button";
import Modal from "../../../components/modal/modal";
import Input from "../../../components/inputs/input/input";
import InputTextfield from "../../../components/inputs/inputTextfield/inputTextfield";
import { IoCloudUpload, IoDownload } from "react-icons/io5";
import { getApiInstance } from "../../../utils/api";
import TableEditable from "../../../components/tableEditable/tableEditable";
import FileList from "../../../components/fileList/fileList.jsx";
import { formatDateComment } from "../../../utils/utils";
import { BiExport } from "react-icons/bi";
import { PiWarning } from "react-icons/pi";
import { AiOutlineWarning } from "react-icons/ai";
import { IoMdClose } from "react-icons/io";
import "./gestionEspecialesProveedor.scss";
import icono1 from "../../../assets/img/icono1.jpg";
import icono2 from "../../../assets/img/icono2.jpg";
import Tag from "../../../components/tag/tag.jsx";
import Accordion from "../../../components/accordion/accordion.jsx";
import { FiFilter } from "react-icons/fi";

export default function GestionEspecialesProveedor({ user }) {
  const api = getApiInstance();
  const notificationRef = useRef();
  const location = useLocation();
  const { hash, pathname, search } = location;

  const [searchTerm, setSearchTerm] = useState("");
  const [tiendasOptions, setTiendasOptions] = useState([]);
  const [selectedTienda, setSelectedTienda] = useState(null);
  const [especiales, setEspeciales] = useState([]);
  const [loading, setLoading] = useState(false);

  // import modal
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);
  const [importFile, setImportFile] = useState(null);
  const [importNombre, setImportNombre] = useState("");
  const [isImporting, setIsImporting] = useState(false);

  // comentarios por fila (mapa por referencia)
  const [comentariosProveedorMap, setComentariosProveedorMap] = useState({});
  const [comentariosAtlanteMap, setComentariosAtlanteMap] = useState({});
  const [comentariosPorFila, setComentariosPorFila] = useState({});

  // Estado para el modal de comentarios
  const [isComentariosModalOpen, setIsComentariosModalOpen] = useState(false);
  const [comentarioModalRow, setComentarioModalRow] = useState(null);
  const [comentarioModalInput, setComentarioModalInput] = useState("");
  const [comentarioModalFiles, setComentarioModalFiles] = useState([]);
  const [comentarioModalInputFileText, setComentarioModalInputFileText] =
    useState("Selecciona un archivo");
  const [selectedEspeciales, setSelectedEspeciales] = useState([]);

  // Estado para trackear comentarios vistos por el usuario
  // Estado para trackear actividades vistas por el usuario (IdDetalle -> objeto con fechas)
  const [actividadesVistas, setActividadesVistas] = useState(() => {
    const codUsuario = user?.codUsuario ?? user?.CodUsuario ?? 'default';
    const stored = localStorage.getItem(`actividadesVistas_${codUsuario}`);
    try {
      return stored ? new Map(Object.entries(JSON.parse(stored))) : new Map();
    } catch {
      return new Map();
    }
  });

  // Estados para manejar referencias duplicadas
  const [isConfirmPopupOpen, setIsConfirmPopupOpen] = useState(false);
  const [importConfirmData, setImportConfirmData] = useState(null);
  const [duplicadasModalOpen, setDuplicadasModalOpen] = useState(false);
  const [duplicadasModalData, setDuplicadasModalData] = useState([]);

    // Estado para el modal de filtros
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [filterTienda, setFilterTienda] = useState([]);
    const [filterUnidad, setFilterUnidad] = useState([]);
    const [filterAprobado, setFilterAprobado] = useState([]);
    const [filterTiendasCerradas, setFilterTiendasCerradas] = useState(false);
    const [filterTiendasAbiertas, setFilterTiendasAbiertas] = useState(false);

  const [tiendasAbiertas, setTiendasAbiertas] = useState([]);
  const [tiendasRaw, setTiendasRaw] = useState([]);

  const formatNumber = (value) => {
    if (value === null || value === undefined || value === "") return "";
    const n = Number(value);
    if (isNaN(n)) return String(value);
    return n.toLocaleString();
  };

  const fetchTiendas = async () => {
    try {
      const res = await api.get("/api/Presupuestos/tiendas");
      if (res && res.status === 200 && Array.isArray(res.data)) {
        const opts = res.data.map((t) => {
          const codigo = t.Codigo ?? t.codigo ?? "";
          const cadena = t.Cadena ?? t.cadena ?? "";
          const ciudad = t.Ciudad ?? t.ciudad ?? "";
          const pais = t.Pais ?? t.pais ?? "";
          
          let label = `${codigo} - ${cadena}`;
          if (ciudad || pais) {
            const ubicacion = [ciudad, pais].filter(Boolean).join(", ");
            if (ubicacion) {
              label += ` (${ubicacion})`;
            }
          }

          label+= `${t.fechaCierre ? " (C)" : ""}`;
          
          return {
            label: label.trim(),
            value: codigo,
            tienda: {
              ...t,
              CodTienda:
                t.CodTienda ??
                t.codTienda ??
                t.Id ??
                t.id ??
                t.Codigo ??
                t.codigo ??
                "",
            },
          };
        });
        setTiendasOptions(opts);
        setTiendasRaw(res.data);
      } else {
        setTiendasOptions([]);
        setTiendasRaw([]);
      }
    } catch (err) {
      console.error("Error cargando tiendas (especiales):", err);
      setTiendasOptions([]);
      setTiendasRaw([]);
    }
  };

  const fetchEspeciales = async (codTienda = "") => {
    try {
      setLoading(true);

      // Usar el nuevo endpoint global que maneja tanto vista general como filtrada por tienda
      const params = new URLSearchParams();
      if (codTienda) {
        params.append('codTienda', codTienda);
      }
      if (searchTerm) {
        params.append('q', searchTerm);
      }
      params.append('top', '1000');

      const url = `/api/GOI/Especiales/Global?${params.toString()}`;
      const res = await api.get(url);
      
      if (res && res.status === 200 && Array.isArray(res.data)) {
        setEspeciales(res.data);
      } else {
        setEspeciales([]);
      }
    } catch (err) {
      console.error("Error cargando mobiliario especial:", err);
      setEspeciales([]);
      notificationRef.current?.addNotification(
        "Error cargando mobiliario especial.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const fetchComentarios = async () => {
    const api = getApiInstance();
    try {
      const response = await api.get(
        `/api/Mueble/GetAllComentariosPresupuesto/${comentarioModalRow.idDetalle}`
      );

      if (response.status !== 200) {
        notificationRef.current?.addNotification(
          "Error cargando comentarios.",
          "error"
        );
        return;
      }

      const comentarios = response.data.map((com) => ({
        codComentario: com.codComentario,
        comentario: com.comentario,
        nombreUsuario:
          com.nombreUsuario == user.nombre ? "Tú" : com.nombreUsuario,
        fecha: formatDateComment(com.fecha),
        rutasArchivos: com.rutasArchivos || [],
      }));

      // Actualiza el estado de comentarios por fila

      setComentariosPorFila((prev) => {
        const id = comentarioModalRow.idDetalle;
        const prevList = prev[id] ?? [];

        // Índice por codComentario para mezclar sin duplicar
        const map = new Map(prevList.map((c) => [c.codComentario, c]));

        for (const c of comentarios) {
          // Si ya existe, actualízalo; sino, añádelo
          map.set(c.codComentario, {
            ...(map.get(c.codComentario) ?? {}),
            ...c,
          });
        }

        const merged = Array.from(map.values());

        return {
          ...prev,
          [id]: merged,
        };
      });
    } catch (error) {
      console.error(error);
    }
  };

  const fetchSendNotification = async (comentario) => {
    try {
      const api = getApiInstance();

      const formData = new FormData();

      // Obtener información detallada del mueble para la notificación
      const referencia = comentarioModalRow?.referencia ?? 
                        comentarioModalRow?.Referencia ?? 
                        comentarioModalRow?.CodigoEspecial ?? 
                        comentarioModalRow?.Codigo ?? 
                        "Sin referencia";
      
      const tiendaNombre = selectedTienda?.label ?? 
                          selectedTienda?.tienda?.Codigo ?? 
                          "Tienda no especificada";

      // Obtener nombre del proveedor que envía el comentario
      const codEmpresa = user?.codEmpresa ?? user?.CodEmpresa ?? "";
      const nombreProveedor = empresaNombres[codEmpresa] || "Proveedor desconocido";

      // Crear mensaje claro y bien estructurado para admin Atlante
      const mensajeDetallado = `Comentario: "${comentario.comentario}" | Proveedor: ${nombreProveedor} | Tienda: ${tiendaNombre}`;

      // Tipos destinatarios
      // None = 0,
      // Admin = 1,
      // Todos = 2,
      // Personalizado = 3
      // AdminProveedores = 4

      // Enviar notificación correcta con todos los campos necesarios
      formData.append("DestinatariosNotificacion", 4); // AdminProveedores
      formData.append("CodUsuarioNotifica", user.codUsuario); // Usuario que crea la notificación
      formData.append("Mensaje", mensajeDetallado); // Mensaje con detalles
      formData.append("Titulo", `Nuevo comentario en especiales - ${referencia}`); // Título con referencia

      // Tipos notificación (sin aplicación en el front por ahora)
      // Info = 0,
      // Warning = 1,
      // Error = 2

      formData.append("TipoNotificacion", 0);
      
      // Construir URL que apunte a la página correcta de presupuestos con el tab de especiales activo
      // y incluir parámetros para navegación directa al comentario
      const codEmpresaProveedor = user?.codEmpresa ?? user?.CodEmpresa ?? '';
      const enlaceConParametros = `/admin/presupuestos?activeTab=mobiliarioEspecial&comentario=${comentarioModalRow?.idDetalle}&codComentario=${comentario.codComentario}&proveedor=${codEmpresaProveedor}`;
      
      // Usar URL completa con parámetros para navegación directa
      formData.append("Enlace", enlaceConParametros);

      let response = await api.post(`/api/Notificaciones`, formData);
    } catch (error) {
      console.error("Error adding notifications data:", error);
    }
  };

  const fetchSendNotificationImportacion = async (nombreTienda) => {
    try {
      const api = getApiInstance();
      const formData = new FormData();

      // Mapeo de códigos de empresa a nombres de proveedor
      const empresaNombres = {
        1: "Grupo Atlante",
        2: "Bershka Imagen",
        3: "Bershka Obras",
        4: "Castel",
        5: "Culdesac",
        6: "Dimalnox",
        7: "Kimak",
        8: "Malasa Mexico",
        9: "Malasa",
        87: "TestEmpresa",
      };

      // Obtener nombre del proveedor
      const codEmpresa = user?.codEmpresa ?? user?.CodEmpresa ?? "";
      const nombreProveedor = empresaNombres[codEmpresa] || "Proveedor desconocido";

      // Crear título y mensaje de la notificación
      const titulo = `Nuevo mobiliario especial importado por ${nombreProveedor}`;
      const mensaje = `Tienda: ${nombreTienda}`;

      // Enviar notificación a administradores (tipo 1 = Admin)
      formData.append("DestinatariosNotificacion", 1);
      formData.append("CodUsuarioNotifica", user.codUsuario);
      formData.append("Mensaje", mensaje);
      formData.append("Titulo", titulo);
      formData.append("TipoNotificacion", 0); // Info
      
      // Enlace para navegar directamente al tab de "Mobiliario especial"
      const codEmpresaProveedor = user?.codEmpresa ?? user?.CodEmpresa ?? '';
      const enlace = `/admin/presupuestos?activeTab=mobiliarioEspecial&proveedor=${codEmpresaProveedor}`;
      formData.append("Enlace", enlace);

      await api.post(`/api/Notificaciones`, formData);
    } catch (error) {
      console.error("Error enviando notificación de importación de especiales:", error);
    }
  };

  useEffect(() => {
    if (isComentariosModalOpen && comentarioModalRow) {
      fetchComentarios();
    }
  }, [isComentariosModalOpen, comentarioModalRow]);

  useEffect(() => {
    fetchTiendas();
  }, [user]);

  useEffect(() => {
    // Cargar especiales cuando cambie la tienda seleccionada, el usuario o el término de búsqueda
    fetchEspeciales(selectedTienda?.tienda?.CodTienda || "");
  }, [user, selectedTienda, searchTerm]);

  const filtered = useMemo(() => {
    let result = especiales;
    
    // Filtrar por término de búsqueda si existe
    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      result = result.filter((p) =>
        Object.values(p || {})
          .map((v) => (v === null || v === undefined ? "" : String(v)))
          .join(" ")
          .toLowerCase()
          .includes(term)
      );
    }
    
    // Agrupar por tienda y ordenar por estado de aprobación
    const grouped = {};
    
    result.forEach((item) => {
      // Usar el código de tienda seleccionada como clave de agrupación
      const tiendaKey = selectedTienda?.tienda?.Codigo ?? selectedTienda?.value ?? "Sin tienda";
      
      if (!grouped[tiendaKey]) {
        grouped[tiendaKey] = [];
      }
      grouped[tiendaKey].push(item);
    });
    
    // Ordenar cada grupo por estado de aprobación (NO aprobados primero)
    Object.keys(grouped).forEach((tiendaKey) => {
      grouped[tiendaKey].sort((a, b) => {
        const aAprobado = a?.aprobadoEspecial !== undefined 
          ? a.aprobadoEspecial 
          : a?.AprobadoEspecial;
        const bAprobado = b?.aprobadoEspecial !== undefined 
          ? b.aprobadoEspecial 
          : b?.AprobadoEspecial;
        
        // NO aprobados (false) primero, luego aprobados (true)
        if (aAprobado === bAprobado) return 0;
        if (aAprobado && !bAprobado) return 1;
        if (!aAprobado && bAprobado) return -1;
        return 0;
      });
    });
    
    // Convertir de vuelta a array plano manteniendo el agrupamiento
    const finalResult = [];
    Object.keys(grouped).sort().forEach((tiendaKey) => {
      finalResult.push(...grouped[tiendaKey]);
    });
    
    return finalResult;
  }, [searchTerm, especiales, selectedTienda]);

  const getRowRef = (row) =>
    row?.CodigoEspecial ??
    row?.Codigo ??
    row?.Cod ??
    row?.codigo ??
    row?.Referencia ??
    row?.ReferenciaTarifa ??
    "";

  // inicializar mapas de comentarios cuando cambian los especiales
  useEffect(() => {
    const pMap = {};
    const aMap = {};
    (especiales || []).forEach((r) => {
      const k = getRowRef(r);
      if (!k) return;
      pMap[k] =
        r?.ComentariosProveedor ??
        r?.ComentarioProveedor ??
        r?.ComentarioProv ??
        r?.Comentarios ??
        "";
      aMap[k] =
        r?.ComentariosAtlante ?? r?.ComentarioAtlante ?? r?.ComentarioAtl ?? "";
    });
    setComentariosProveedorMap(pMap);
    setComentariosAtlanteMap(aMap);
  }, [especiales]);

  const handleFileChange = (e) => {
    const f = e.target.files && e.target.files[0];
    setImportFile(f || null);
  };

  const handleImport = async () => {
    if (
      !selectedTienda ||
      !selectedTienda.tienda ||
      !selectedTienda.tienda.CodTienda
    ) {
      notificationRef.current?.addNotification(
        "Selecciona una tienda válida antes de importar.",
        "warning"
      );
      return;
    }
    if (!importFile) {
      notificationRef.current?.addNotification(
        "Seleccione un archivo Excel.",
        "warning"
      );
      return;
    }
    const codTiendaInt = selectedTienda.tienda.CodTienda;
    if (Number.isNaN(Number(codTiendaInt)) || !codTiendaInt) {
      notificationRef.current?.addNotification(
        "CodTienda inválido. Debe ser numérico.",
        "warning"
      );
      return;
    }
    try {
      setIsImporting(true);
      const form = new FormData();
      form.append("archivoExcel", importFile);
      if (importNombre) form.append("nombre", importNombre);
      const url = `/api/GOI/Tiendas/${encodeURIComponent(
        codTiendaInt
      )}/ImportarEspeciales`;
      const res = await api.post(url, form);
      
      const data = res.data || {};
      
      // Si hay referencias duplicadas, mostrar popup de confirmación
      if (Array.isArray(data.referenciasYaExistian) && data.referenciasYaExistian.length > 0) {
        setImportConfirmData({
          idImportacion: data.idImportacion,
          referenciasDuplicadas: data.referenciasYaExistian,
        });
        setIsConfirmPopupOpen(true);
      } else {
        // Si no hay duplicadas, continuar como antes
        if (res && (res.status === 200 || res.status === 201)) {
          notificationRef.current?.addNotification(
            "Importación completada correctamente.",
            "success"
          );
          
          // Enviar notificación de importación
          const tiendaNombre = selectedTienda?.label ?? selectedTienda?.tienda?.Codigo ?? "Tienda no especificada";
          await fetchSendNotificationImportacion(tiendaNombre);
          
          await fetchEspeciales(selectedTienda.tienda.CodTienda);
          setIsImportModalOpen(false);
          setImportFile(null);
          setImportNombre("");
        } else {
          notificationRef.current?.addNotification(
            "Error en la importación.",
            "error"
          );
        }
      }
    } catch (err) {
      console.error("Error importando especiales:", err);
      const mensaje = err.response?.data?.mensaje || "Error importando el fichero.";
      
      // Detectar si hay referenciasDuplicadasExcel
      if (err.response?.data?.referenciasDuplicadasExcel) {
        setDuplicadasModalData(err.response.data.referenciasDuplicadasExcel);
        setDuplicadasModalOpen(true);
      }
      
      notificationRef.current?.addNotification(mensaje, "error");
    } finally {
      setIsImporting(false);
    }
  };

  // manejar selección dropdown igual que en presupuestosProveedor
  const handleTiendaSelect = (opt) => {
    if (!opt) {
      setSelectedTienda(null);
      return;
    }
    setSelectedTienda(opt);
  };

  const handleChangeComentarioProveedor = (ref, value) => {
    setComentariosProveedorMap((prev) => ({ ...prev, [ref]: value }));
  };

  const handleChangeComentarioAtlante = (ref, value) => {
    setComentariosAtlanteMap((prev) => ({ ...prev, [ref]: value }));
  };

  // Mapa de codEmpresa a nombre de proveedor
  const empresaNombres = {
    1: "Grupo Atlante",
    2: "Bershka Imagen",
    3: "Bershka Obras",
    4: "Castel",
    5: "Culdesac",
    6: "Dimalnox",
    7: "Kimak",
    8: "Malasa Mexico",
    9: "Malasa",
    87: "TestEmpresa",
  };

  // Obtener nombre del proveedor según codEmpresa del usuario logeado
  const codEmpresa =
    user?.codEmpresa ??
    user?.CodEmpresa ??
    user?.empresa ??
    user?.Empresa ??
    "";
  const nombreProveedor = empresaNombres[codEmpresa] || "Proveedor";

  // Acción para aprobar un mueble especial usando el endpoint real
  const handleAprobar = async (row) => {
    try {
      const idDetalle = row.idDetalle;
      if (!idDetalle) {
        notificationRef.current?.addNotification(
          "No se ha encontrado el idDetalle.",
          "error"
        );
        return;
      }
      // Puedes enviar los datos actuales o solo lo necesario
      const body = {
        Aprobar: true,
        PrecioEspecial: row.precioEspecial,
        Unidad: row.unidad,
        Divisa: row.divisa,
        Descripcion: row.descripcion,
      };
      const res = await api.put(
        `/api/GOI/Especiales/Detalles/${idDetalle}/Aprobar`,
        body
      );
      if (res && res.status === 200) {
        notificationRef.current?.addNotification(
          `Mueble con referencia ${
            row.referencia ?? row.Referencia ?? "-"
          } aprobado correctamente.`,
          "success"
        );
        // Refresca la tabla tras aprobar
        await fetchEspeciales(selectedTienda?.tienda?.CodTienda || "");
      } else {
        notificationRef.current?.addNotification(
          "No se pudo aprobar el mueble.",
          "error"
        );
      }
    } catch (err) {
      notificationRef.current?.addNotification(
        "Error al aprobar el mueble.",
        "error"
      );
    }
  };

  // Para edición inline de comentarios proveedor
  const handleEditComentarioProveedor = (row, value) => {
    const ref = getRowRef(row);
    setComentariosProveedorMap((prev) => ({
      ...prev,
      [ref]: value,
    }));
    // Si quieres guardar en backend, aquí puedes hacer un api.post/put
  };

  // Para edición inline de comentarios Atlante
  const handleEditComentarioAtlante = (row, value) => {
    const ref = getRowRef(row);
    setComentariosAtlanteMap((prev) => ({
      ...prev,
      [ref]: value,
    }));
    // Si quieres guardar en backend, aquí puedes hacer un api.post/put
  };

  // Parsear comentarios por proveedor y Atlante desde observaciones
  const parseObservaciones = (observaciones) => {
    if (!observaciones) return [];
    return observaciones.split("|").map((c) => c.trim());
  };

  // Cuando se abre el modal, inicializa el input y archivos
  const handleOpenComentariosModal = (row) => {
    setComentarioModalRow(row);
    setComentarioModalInput("");
    setComentarioModalFiles([]);
    setComentariosPorFila((prev) => ({
        ...prev,
        [row.idDetalle]: getComentariosFromObservaciones(row),
      }));
    
    // Marcar los comentarios como vistos cuando se abre el modal
    const idDetalle = row?.idDetalle ?? row?.IdDetalle;
    if (idDetalle) {
      const fechaActual = new Date().toISOString();
      setActividadesVistas(prev => {
        const newMap = new Map(prev);
        const actividadesPrevias = newMap.get(String(idDetalle)) || {};
        const nuevasActividades = {
          ...actividadesPrevias,
          ultimoComentarioVisto: fechaActual
        };
        newMap.set(String(idDetalle), nuevasActividades);
        // Guardar en localStorage
        const codUsuario = user?.codUsuario ?? user?.CodUsuario ?? 'default';
        localStorage.setItem(`actividadesVistas_${codUsuario}`, JSON.stringify(Object.fromEntries(newMap)));
        return newMap;
      });
    }
    
    setIsComentariosModalOpen(true);
  };

  const handleCloseComentariosModal = () => {
    setIsComentariosModalOpen(false);
    setComentarioModalRow(null);
    setComentarioModalInput("");
    setComentarioModalFiles([]);
  };

  // Función para marcar aprobación como vista
  const marcarAprobacionComoVista = (row) => {
    const idDetalle = row?.idDetalle ?? row?.IdDetalle;
    if (idDetalle) {
      const fechaActual = new Date().toISOString();
      setActividadesVistas(prev => {
        const newMap = new Map(prev);
        const actividadesPrevias = newMap.get(String(idDetalle)) || {};
        const nuevasActividades = {
          ...actividadesPrevias,
          aprobacionVista: fechaActual
        };
        newMap.set(String(idDetalle), nuevasActividades);
        // Guardar en localStorage
        const codUsuario = user?.codUsuario ?? user?.CodUsuario ?? 'default';
        localStorage.setItem(`actividadesVistas_${codUsuario}`, JSON.stringify(Object.fromEntries(newMap)));
        return newMap;
      });
    }
  };

  // Función para marcar importación como vista
  const marcarImportacionComoVista = (row) => {
    const idDetalle = row?.idDetalle ?? row?.IdDetalle;
    if (idDetalle) {
      const fechaActual = new Date().toISOString();
      setActividadesVistas(prev => {
        const newMap = new Map(prev);
        const actividadesPrevias = newMap.get(String(idDetalle)) || {};
        const nuevasActividades = {
          ...actividadesPrevias,
          importacionVista: fechaActual
        };
        newMap.set(String(idDetalle), nuevasActividades);
        // Guardar en localStorage
        const codUsuario = user?.codUsuario ?? user?.CodUsuario ?? 'default';
        localStorage.setItem(`actividadesVistas_${codUsuario}`, JSON.stringify(Object.fromEntries(newMap)));
        return newMap;
      });
    }
  };

  // Manejar archivos en el modal
  const handleComentarioModalFiles = (event) => {
    const filesArray = Array.from(event.target.files);
    setComentarioModalFiles((prevFiles) => [
      ...prevFiles,
      ...filesArray.filter(
        (file) => !prevFiles.some((prevFile) => prevFile.name === file.name)
      ),
    ]);
  };

  useEffect(() => {
    if (comentarioModalFiles.length === 0) {
      setComentarioModalInputFileText("Selecciona un archivo");
    } else {
      setComentarioModalInputFileText(
        `${comentarioModalFiles.length} ${
          comentarioModalFiles.length > 1
            ? "archivos seleccionados"
            : "archivo seleccionado"
        }`
      );
    }
  }, [comentarioModalFiles]);

  // Simulación de envío de comentario (puedes adaptar para llamar a tu API)
  const handleEnviarComentarioModal = async () => {
    if (!comentarioModalInput.trim() || !comentarioModalRow) return;
    try {
      const fecha = new Date();
      const formData = new FormData();

      formData.append("CodEspecial", comentarioModalRow.idDetalle);
      formData.append("Comentario", comentarioModalInput);
      formData.append("Fecha", fecha.toLocaleString());
      comentarioModalFiles.forEach((file) => {
        formData.append("RutasArchivos", file);
      });

      // Usa el endpoint de detalleMueble
      const response = await api.post(
        `/api/Mueble/ComentarioPresupuesto`,
        formData
      );

      if (response.status === 200) {
        notificationRef.current?.addNotification(
          "Comentario creado correctamente.",
          "success"
        );

        const nuevoComentario = {
          codComentario: response.data.codComentario,
          comentario: comentarioModalInput,
          nombreUsuario: "Tú",
          fecha: formatDateComment(fecha.toISOString()),
          rutasArchivos: comentarioModalFiles,
        };

        setComentariosPorFila((prev) => ({
          ...prev,
          [comentarioModalRow.idDetalle]: [
            ...(prev[comentarioModalRow.idDetalle] || []),
            nuevoComentario,
          ],
        }));
        setComentarioModalInput("");
        setComentarioModalFiles([]);

        // Enviar notificación
        await fetchSendNotification(nuevoComentario);
      } else {
        notificationRef.current?.addNotification(
          "Hubo un error al guardar el comentario.",
          "error"
        );
      }
    } catch (error) {
      notificationRef.current?.addNotification(
        "Hubo un error al guardar el comentario.",
        "error"
      );
    }
  };

  // Simulación de comentarios históricos a partir de observaciones
  const getComentariosFromObservaciones = (row) => {
    if (!row?.observaciones) return [];
    
    // Obtener fecha de importación del Excel si está disponible en el futuro
    // Por ahora usamos null hasta que el backend incluya fechaImportacion
    const fechaImportacion = row?.fechaImportacion ?? 
                           row?.FechaImportacion ?? 
                           row?.fechaSubida ?? 
                           row?.FechaSubida ?? 
                           null;
    
    // Formatear fecha de importación si existe
    const fechaImportacionFormateada = fechaImportacion ? formatDateComment(fechaImportacion) : null;
    
    // Divide por "|", luego intenta extraer autor y fecha si están entre corchetes
    return row.observaciones.split("|").map((raw, idx) => {
      const trimmed = raw.trim();
      // Busca patrón tipo: [COMENTARIOS ATLANTE 03/10]: Ok
      const match = trimmed.match(/^\[(.*?)\]:\s*(.*)$/);
      if (match) {
        const autorYFecha = match[1]; // Ej: "COMENTARIOS ATLANTE 03/10"
        const comentario = match[2];
        // Intenta separar autor y fecha si hay fecha
        const autorFechaMatch = autorYFecha.match(/^(.*?)(\d{2}\/\d{2})?$/);
        let nombreUsuario = autorYFecha;
        let fecha = null;
        if (autorFechaMatch) {
          nombreUsuario = autorFechaMatch[1]
            .replace(/COMENTARIOS\s*/i, "")
            .trim();
          fecha = autorFechaMatch[2] || fechaImportacionFormateada;
        }
        return {
          codComentario: idx,
          comentario: comentario.trim(),
          nombreUsuario: nombreUsuario || "Desconocido",
          fecha: fecha || fechaImportacionFormateada,
          rutasArchivos: [],
        };
      }
      // Si no hay patrón, muestra como comentario genérico con fecha de importación
      return {
        codComentario: idx,
        comentario: trimmed,
        nombreUsuario: "Desconocido",
        fecha: fechaImportacionFormateada,
        rutasArchivos: [],
      };
    });
  };

  // Obtener tipo de empresa del usuario
  const codTipoEmpresa =
    user?.codTipoEmpresa ??
    user?.CodTipoEmpresa ??
    user?.tipoEmpresa ??
    user?.TipoEmpresa ??
    "";

  // Función para determinar el tipo de actividad reciente de un mueble
  const getActividadReciente = (row) => {
    const ahora = new Date();
    
    // 0. Verificar primero si hay actividad general reciente (FechaUltimaModificacion)
    const fechaModificacion = row?.fechaUltimaModificacion || row?.FechaUltimaModificacion;
    if (fechaModificacion) {
      try {
        const dateModificacion = new Date(fechaModificacion);
        if (!isNaN(dateModificacion.getTime())) {
          const diasDiferencia = (ahora - dateModificacion) / (1000 * 60 * 60 * 24);
          
          // Si la última modificación es muy antigua (más de 2 días), no mostrar warning
          if (diasDiferencia > 2) {
            return null; // Sin actividad reciente
          }
        }
      } catch {
        // Si falla el parsing, continuar con la lógica normal
      }
    }
    
    // 1. Verificar actividad reciente comparando fechas específicas
    const fechaComentario = row?.fechaUltimoComentario || row?.FechaUltimoComentario;
    const fechaAprobacion = row?.fechaUltimaAprobacion || row?.FechaUltimaAprobacion;
    
    let ultimaAccion = null;
    let fechaUltimaAccion = null;
    
    // Determinar cuál fue la última acción comparando fechas
    if (fechaComentario && fechaAprobacion) {
      const dateComentario = new Date(fechaComentario);
      const dateAprobacion = new Date(fechaAprobacion);
      
      if (dateComentario > dateAprobacion) {
        ultimaAccion = 'comentario';
        fechaUltimaAccion = dateComentario;
      } else {
        ultimaAccion = 'aprobacion';
        fechaUltimaAccion = dateAprobacion;
      }
    } else if (fechaComentario) {
      ultimaAccion = 'comentario';
      fechaUltimaAccion = new Date(fechaComentario);
    } else if (fechaAprobacion) {
      ultimaAccion = 'aprobacion';
      fechaUltimaAccion = new Date(fechaAprobacion);
    }
    
    // Verificar si la última acción fue reciente (últimos 2 días)
    if (ultimaAccion && fechaUltimaAccion && !isNaN(fechaUltimaAccion.getTime())) {
      const diasDiferencia = (ahora - fechaUltimaAccion) / (1000 * 60 * 60 * 24);
      
      if (diasDiferencia <= 2) {
        if (ultimaAccion === 'comentario') {
          const idDetalle = row?.idDetalle ?? row?.IdDetalle;
          
          // Verificar si hay comentarios más recientes que la última vez que los vio el usuario
          const actividadesDelMueble = actividadesVistas.get(String(idDetalle)) || {};
          const fechaUltimoComentarioVisto = actividadesDelMueble.ultimoComentarioVisto;
          if (fechaUltimoComentarioVisto && new Date(fechaComentario) <= new Date(fechaUltimoComentarioVisto)) {
            return null;
          }
          
          const horasDiferencia = Math.floor((ahora - fechaUltimaAccion) / (1000 * 60 * 60));
          if (horasDiferencia < 1) {
            return { tipo: 'comentario', mensaje: 'Nuevo comentario' };
          } else if (horasDiferencia < 24) {
            return { tipo: 'comentario', mensaje: `Comentario hace ${horasDiferencia}h` };
          } else {
            return { tipo: 'comentario', mensaje: `Comentario hace ${Math.floor(diasDiferencia)} día${Math.floor(diasDiferencia) !== 1 ? 's' : ''}` };
          }
        } else if (ultimaAccion === 'aprobacion') {
          const horasDiferencia = Math.floor((ahora - fechaUltimaAccion) / (1000 * 60 * 60));
          const aprobado = row?.aprobadoEspecial ?? row?.AprobadoEspecial;
          const accion = aprobado ? 'Aprobado' : 'Desaprobado';
          
          if (horasDiferencia < 1) {
            return { tipo: 'aprobacion', mensaje: `${accion} recientemente` };
          } else if (horasDiferencia < 24) {
            return { tipo: 'aprobacion', mensaje: `${accion} hace ${horasDiferencia}h` };
          } else {
            return { tipo: 'aprobacion', mensaje: `${accion} hace ${Math.floor(diasDiferencia)} día${Math.floor(diasDiferencia) !== 1 ? 's' : ''}` };
          }
        }
      }
    }
    
    // 2. Si no hay fechas específicas pero FechaUltimaModificacion es reciente,
    // verificar si es nuevo por IdImportacion
    if (fechaModificacion) {
      try {
        const dateModificacion = new Date(fechaModificacion);
        const diasDiferencia = (ahora - dateModificacion) / (1000 * 60 * 60 * 24);
        
        if (diasDiferencia <= 2 && esNuevoPorImportacion(row)) {
          return { tipo: 'nuevo', mensaje: 'Mueble recién importado' };
        }
      } catch {
        // Continuar con las verificaciones de fallback
      }
    }
    
    // 3. Verificar actividad reciente por comentarios del modal (fallback)
    const comentarios = comentariosPorFila[row?.idDetalle ?? row?.IdDetalle] || [];
    if (comentarios.length > 0) {
      const idDetalle = row?.idDetalle ?? row?.IdDetalle;
      
      // Verificar si hay comentarios más recientes que la última vez que los vio el usuario
      const actividadesDelMueble = actividadesVistas.get(String(idDetalle)) || {};
      const fechaUltimoComentarioVisto = actividadesDelMueble.ultimoComentarioVisto;
      if (fechaUltimoComentarioVisto) {
        // Si hay fecha de última visualización, verificar si hay comentarios más recientes
        const hayComentariosNuevos = comentarios.some(com => {
          if (!com.fecha) return false;
          try {
            const fechaComentario = new Date(com.fecha);
            return fechaComentario > new Date(fechaUltimoComentarioVisto);
          } catch {
            return false;
          }
        });
        
        if (!hayComentariosNuevos) {
          return null;
        }
      }
      
      const comentariosRecientes = comentarios.filter(com => {
        if (!com.fecha) return false;
        
        try {
          let fechaComentario;
          if (typeof com.fecha === 'string') {
            if (com.fecha.includes('hace')) return true;
            fechaComentario = new Date(com.fecha);
          } else {
            fechaComentario = new Date(com.fecha);
          }
          
          if (isNaN(fechaComentario.getTime())) return false;
          
          const diasDiferencia = (ahora - fechaComentario) / (1000 * 60 * 60 * 24);
          return diasDiferencia <= 2;
        } catch {
          return false;
        }
      });
      
      if (comentariosRecientes.length > 0) {
        return { tipo: 'comentario', mensaje: 'Mueble con comentarios recientes' };
      }
    }
    
    return null; // Sin actividad reciente
  };

  // Función auxiliar para verificar si es nuevo por importación
  const esNuevoPorImportacion = (row) => {
    if (row?.idImportacion !== undefined || row?.IdImportacion !== undefined) {
      const idImportacion = row.idImportacion ?? row.IdImportacion;
      const maxIdImportacion = Math.max(
        ...especiales.map(e => e.idImportacion ?? e.IdImportacion ?? 0)
      );
      return maxIdImportacion === idImportacion;
    }
    return false;
  };

  // Función auxiliar para verificar si es nuevo por IdDetalle
  const esNuevoPorIdDetalle = (row) => {
    if (row?.idDetalle !== undefined || row?.IdDetalle !== undefined) {
      const idDetalle = row.idDetalle ?? row.IdDetalle;
      const maxIdDetalle = Math.max(
        ...especiales.map(e => e.idDetalle ?? e.IdDetalle ?? 0)
      );
      const umbralNuevo = maxIdDetalle - 50;
      return idDetalle > umbralNuevo;
    }
    return false;
  };

  // Función para mantener compatibilidad (usa la nueva lógica)
  const esMuebleNuevo = (row) => {
    const actividad = getActividadReciente(row);
    return actividad !== null;
  };

  const columns = [
    {
      key: "nuevo",
      label: "",
      render: (row) => {
        const actividad = getActividadReciente(row);
        if (actividad) {
          const { mensaje, tipo } = actividad;
          
          const handleWarningClick = () => {
            if (tipo === 'aprobacion') {
              marcarAprobacionComoVista(row);
            } else if (tipo === 'nuevo') {
              marcarImportacionComoVista(row);
            }
            // Los comentarios se marcan como vistos cuando se abre el modal, no aquí
          };
          
          // Renderizar imagen personalizada según el tipo de actividad
          if (tipo === 'nuevo') {
            return (
              <div 
                style={{ 
                  display: 'flex', 
                  justifyContent: 'center', 
                  alignItems: 'center',
                  fontSize: '18px',
                  cursor: 'pointer'
                }}
                title={mensaje}
                onClick={handleWarningClick}
              >
                <img 
                  src={icono1} 
                  alt="Mueble recién importado"
                  style={{ 
                    width: '20px', 
                    height: '20px',
                    objectFit: 'contain'
                  }}
                />
              </div>
            );
          } else if (tipo === 'aprobacion') {
            return (
              <div 
                style={{ 
                  display: 'flex', 
                  justifyContent: 'center', 
                  alignItems: 'center',
                  fontSize: '18px',
                  cursor: 'pointer'
                }}
                title={mensaje}
                onClick={handleWarningClick}
              >
                <img 
                  src={icono2} 
                  alt="Estado de aprobación actualizado"
                  style={{ 
                    width: '20px', 
                    height: '20px',
                    objectFit: 'contain'
                  }}
                />
              </div>
            );
          } else {
            return (
              <div 
                style={{ 
                  display: 'flex', 
                  justifyContent: 'center', 
                  alignItems: 'center',
                  color: '#ff9800',
                  fontSize: '18px',
                  cursor: 'default'
                }}
                title={mensaje}
              >
                <AiOutlineWarning />
              </div>
            );
          }
        }
        return null;
      },
      editable: false,
      width: 50,
    },
    {
      key: "referencia",
      label: "Referencia",
      render: (row) =>
        row?.referencia ??
        row?.Referencia ??
        row?.CodigoEspecial ??
        row?.Codigo ??
        row?.Cod ??
        row?.codigo ??
        row?.ReferenciaTarifa ??
        "-",
      editable: false,
    },
    {
      key: "codigoTienda",
      label: "Código Tienda",
        render: (r) => {
                const nombre = r?.tiendaCodigo ??
                r?.TiendaCodigo ??
                r?.codigoTienda ??
                r?.CodigoTienda ??
                "-";
                const cerrada = r.tiendaCerrada ?? false;
                
                return (
                    <span style={{ color: cerrada ? "red" : "inherit" , fontWeight: cerrada ? "bold" : "normal"}}>
                        {nombre}
                        {cerrada && " (Cerrada)"}
                    </span>
                );
            },
      editable: false,
    },
    {
      key: "nombreTienda",
      label: "Nombre Tienda",
      render: (row) =>
        row?.tiendaNombre ??
        row?.TiendaNombre ??
        row?.nombreTienda ??
        row?.NombreTienda ??
        "-",
      editable: false,
    },
    {
      key: "tiendaPais",
      label: "País",
      render: (row) =>
        row?.tiendaPais ??
        row?.TiendaPais ??
        row?.pais ??
        row?.Pais ??
        "-",
      editable: false,
    },
    {
      key: "tiendaCiudad",
      label: "Ciudad",
      render: (row) =>
        row?.tiendaCiudad ??
        row?.TiendaCiudad ??
        row?.ciudad ??
        row?.Ciudad ??
        "-",
      editable: false,
    },
    {
      key: "descripcion",
      label: "Descripcion",
      render: (row) =>
        row?.descripcion ??
        row?.Descripcion ??
        row?.DescripcionArticulo ??
        row?.DescripcionTarifa ??
        row?.descrip ??
        row?.DescripcionImportacion ??
        "-",
      editable: false,
    },
    {
      key: "precio",
      label: "Precio",
      render: (row) =>
        formatNumber(
          row?.precioGOI ??
            row?.PrecioGOI ??
            row?.precioEspecial ??
            row?.PrecioEspecial ??
            row?.Precio ??
            row?.precio ??
            0
        ),
      editable: false,
    },
    {
      key: "unidad",
      label: "Unidad",
      render: (row) =>
        row?.unidad ??
        row?.Unidad ??
        row?.Unidades ??
        row?.UM ??
        row?.um ??
        row?.UnidadImportacion ??
        "-",
      editable: false,
    },
    {
      key: "aprobadoEspecial",
      label: "Aprobado",
      render: (row) =>
        row?.aprobadoEspecial !== undefined
          ? row.aprobadoEspecial
            ? "Sí"
            : "No"
          : row?.AprobadoEspecial
          ? "Sí"
          : "No",
      editable: false,
    },
    {
      key: "verComentarios",
      label: "Comentarios",
      render: (row) => (
        <Button
          label="Ver comentarios"
          variant="outlined"
          onClick={() => handleOpenComentariosModal(row)}
        />
      ),
      editable: false,
    },
    // Solo muestra la columna de acciones si el usuario NO es proveedor
    ...(codTipoEmpresa === 3
      ? []
      : [
          {
            key: "acciones",
            label: "Acciones",
            render: (row) => (
              <Button
                label="Aprobar"
                variant="filled"
                onClick={() => handleAprobar(row)}
              />
            ),
            editable: false,
          },
        ]),
  ];

  // Función para manejar la decisión de sobrescribir
  const handleSobrescribir = async () => {
    await handleDecisionImportacion("actualizar");
    setIsConfirmPopupOpen(false);
  };

  // Función para manejar la decisión de añadir solo nuevas
  const handleSoloNuevas = async () => {
    await handleDecisionImportacion("solonuevas");
    setIsConfirmPopupOpen(false);
  };

  const handleSobrescribirCompleto = async () => {
    await handleDecisionImportacion("sobrescribirespeciales");
    setIsConfirmPopupOpen(false);
  };

  // Función para aplicar decisión del usuario
  const handleDecisionImportacion = async (modo) => {
    if (!importConfirmData?.idImportacion) return;
    try {
      await api.post("/api/GOI/AplicarDecisionImportacionEspeciales", {
        IdImportacion: importConfirmData.idImportacion,
        Modo: modo,
      });
      // Recargar datos tras aplicar decisión
      await fetchEspeciales(selectedTienda.tienda.CodTienda);
      
      // Enviar notificación de importación
      const tiendaNombre = selectedTienda?.label ?? selectedTienda?.tienda?.Codigo ?? "Tienda no especificada";
      await fetchSendNotificationImportacion(tiendaNombre);
      
      setIsImportModalOpen(false);
      setImportFile(null);
      setImportNombre("");
      setImportConfirmData(null);
      notificationRef.current?.addNotification("Decisión aplicada correctamente", "success");
    } catch (error) {
      notificationRef.current?.addNotification("Error al aplicar decisión", "error");
    }
  };

  const openImportModal = () => {
    setImportFile(null);
    setImportNombre("");
    setIsImportModalOpen(true);
  };
  const closeImportModal = () => setIsImportModalOpen(false);

    const handleExportExcel = async () => {
      try {
        if (selectedEspeciales.length === 0) {
          notificationRef.current.addNotification(
            "No hay solicitudes seleccionadas para exportar.",
            "warning"
          );
          return;
        }

        console.log('Exportando especiales seleccionados:', {
          selectedEspeciales,
          cantidad: selectedEspeciales.length
        });

        const api = getApiInstance();
        const response = await api.post(
          `/api/GOI/Especiales/ExportarSeleccionados`,
          selectedEspeciales,
          { responseType: "blob" }
        );
  
        if (response.status !== 200) {
          throw new Error("Error al descargar el archivo");
        }
  
        const blob = await response.data;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
  
        let fileName = "Especiales_GOI.xlsx";
        const disposition = response.headers.get("Content-Disposition");
        if (disposition && disposition.indexOf("filename=") !== -1) {
          const fileNameMatch = disposition.match(/filename="?([^"]+)"?/);
          if (fileNameMatch && fileNameMatch.length > 1) {
            fileName = fileNameMatch[1];
          }
        }
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
  
        notificationRef.current.addNotification(
          "Archivo descargado correctamente.",
          "success"
        );
      } catch (error) {
        notificationRef.current.addNotification(
          "Error al descargar el archivo.",
          "error"
        );
        console.error("Error al descargar el archivo:", error);
      }
    };

  const handleDescargarPlantilla = async () => {
    try {
      const api = getApiInstance();
      const response = await api.get(
        "/api/GOI/DescargarPlantillaEspeciales",
        { responseType: "blob" }
      );

      if (response.status !== 200) {
        throw new Error("Error al descargar la plantilla");
      }

      const blob = await response.data;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;

      let fileName = "PLANTILLAESPECIALES_V01_CODIGOTIENDA.xlsx";
      const disposition = response.headers.get("Content-Disposition");
      if (disposition && disposition.indexOf("filename=") !== -1) {
        const fileNameMatch = disposition.match(/filename="?([^"]+)"?/);
        if (fileNameMatch && fileNameMatch.length > 1) {
          fileName = fileNameMatch[1];
        }
      }
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      notificationRef.current.addNotification(
        "Plantilla descargada correctamente.",
        "success"
      );
    } catch (error) {
      notificationRef.current.addNotification(
        "Error al descargar la plantilla.",
        "error"
      );
      console.error("Error al descargar la plantilla:", error);
    }
  };
  
    useEffect(() => {
      setTiendasAbiertas(tiendasRaw.filter((t) => !t.fechaCierre).map(x=>x.codTienda));
  }, [tiendasRaw]);

    const tiendas = useMemo(() => {
      return especiales
        .map((e) => e.tiendaNombre ?? e.TiendaNombre)
        .filter((v, i, arr) => v && arr.indexOf(v) === i);
    }, [especiales]);
    const unidades = useMemo(() => {
      return especiales
        .map((e) => e.unidad)
        .filter((v, i, arr) => v && arr.indexOf(v) === i);
    }, [especiales]);
    const aprobados = ["Aprobado", "No aprobado"];

  const filteredEspeciales = useMemo(() => {
      // El backend ya maneja searchTerm y selectedProveedor
      // Solo aplicamos filtros locales de la modal de filtros
      let filtered = especiales;
  
      if (filterTienda.length > 0) {
        filtered = filtered.filter((e) =>
          filterTienda.includes(e.tiendaNombre ?? e.TiendaNombre)
        );
      }
      if (filterUnidad.length > 0) {
        filtered = filtered.filter((e) => filterUnidad.includes(e.unidad));
      }
  
      if (filterTiendasCerradas) {
        filtered = filtered.filter((item) => {
          return item.tiendaCerrada;
        });
      }
  
      if (filterTiendasAbiertas) {
        filtered = filtered.filter((item) => {
          return !item.tiendaCerrada;
        });
      }
  
      if (filterAprobado.length > 0) {
        filtered = filtered.filter((e) => {
          const aprobado = e.aprobadoEspecial ?? e.AprobadoEspecial;
          if (filterAprobado.includes("Aprobado")) return aprobado === true;
          if (filterAprobado.includes("No aprobado")) return aprobado === false;
          return true;
        });
      }
      return [...filtered].sort((a, b) => {
  const av = a.tiendaCerrada === false ? 0
           : a.tiendaCerrada === true  ? 1
           : 2; // undefined / null / otros => al final

  const bv = b.tiendaCerrada === false ? 0
           : b.tiendaCerrada === true  ? 1
           : 2;

  return av - bv;
});
;
    }, [especiales, searchTerm, filterTienda, filterUnidad, filterAprobado, filterTiendasCerradas, filterTiendasAbiertas]);
  
    const handleSelectTienda = (nombre) => {
      setFilterTienda((prev) =>
        prev.includes(nombre)
          ? prev.filter((t) => t !== nombre)
          : [...prev, nombre]
      );
    };
    const handleSelectUnidad = (unidad) => {
      setFilterUnidad((prev) =>
        prev.includes(unidad)
          ? prev.filter((u) => u !== unidad)
          : [...prev, unidad]
      );
    };
    const handleSelectAprobado = (estado) => {
      setFilterAprobado((prev) =>
        prev.includes(estado)
          ? prev.filter((a) => a !== estado)
          : [...prev, estado]
      );
    };
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);
    const handleAcceptFilters = () => closeModal();
    const handleCleanFilter = () => {
      setFilterTienda([]);
      setFilterUnidad([]);
      setFilterAprobado([]);
      setFilterTiendasCerradas(false);
    };
  
   const handleSelectTiendasCerradas = () => {
          if(filterTiendasCerradas){
              setFilterTiendasCerradas(false)
          } else {
              if(filterTiendasAbiertas){
                  setFilterTiendasAbiertas(false)
              }
              setFilterTiendasCerradas(true)
          }
      }
  
      const handleSelectTiendasAbiertas = () => {
          if(filterTiendasAbiertas){
              setFilterTiendasAbiertas(false)
          } else {
              if(filterTiendasCerradas){
                  setFilterTiendasCerradas(false)
              }
              setFilterTiendasAbiertas(true)
          }
      }

  return (
    <section className="dashboard-usuarios">
      <div className="dashboard-usuarios__content__table-header">
        <InputSearch
          context="tableSearch"
          placeholder="Buscar..."
          onSearch={setSearchTerm}
        />
        <div style={{ width: "360px" }}>
          <InputDropdown
            options={tiendasOptions}
            onSelect={handleTiendaSelect}
            placeholder="Seleccionar tienda"
            showLabel={false}
            hasSearch={true}
            value={selectedTienda}
          />
        </div>
        <Button label="Filtros" onClick={openModal} icon={<FiFilter />} />      
        <Button
          label="Descargar plantilla"
          icon={<IoDownload />}
          variant="outline"
          onClick={handleDescargarPlantilla}
        />
        <Button
          label="Importar mobiliario"
          icon={<IoCloudUpload />}
          variant="filled"
          onClick={openImportModal}
        />
        <Button
          label="Exportar"
          variant="outline"
          icon={<BiExport />}
          onClick={handleExportExcel}
          disabled={selectedEspeciales.length === 0}
        />
      </div>

      <TableEditable
        data={filteredEspeciales}
        columns={columns}
        noResultsMessage={
          loading ? "Cargando..." : "No se han encontrado registros."
        }
        setData={setEspeciales}
        rowKey="idDetalle"
        notificationRef={notificationRef}
        showHeaderCheckbox={true}
        selectedRows={selectedEspeciales}
        onRowSelect={setSelectedEspeciales}
        onEditCell={(row, key, value) => {
          if (key === "comentariosProveedor")
            handleEditComentarioProveedor(row, value);
          if (key === "comentariosAtlante")
            handleEditComentarioAtlante(row, value);
        }}
        rowClassName={(row) => {
          const isApproved = row?.aprobadoEspecial !== undefined 
            ? row.aprobadoEspecial 
            : row?.AprobadoEspecial;
          return isApproved ? "row-approved" : "";
        }}
      />

      <Notification ref={notificationRef} />

      {/* Modal de comentarios */}
      <Modal
        title={`Comentarios de ${comentarioModalRow?.referencia || ""}`}
        isOpen={isComentariosModalOpen}
        onClose={handleCloseComentariosModal}
        onCancel={handleCloseComentariosModal}
        hideFooter={true}
        className="modal--centered"
      >
        <div className="detalle-mueble__info__comments">
          <div className="detalle-mueble__info__comments__comments-list">
            {comentarioModalRow &&
            (comentariosPorFila[comentarioModalRow.idDetalle] || []).length >
              0 ? (
              <>
                {(comentariosPorFila[comentarioModalRow.idDetalle] || []).map(
                  (com, idx) => (
                    <div
                      key={com.codComentario}
                      className="detalle-mueble__info__comments__comments-list__item"
                    >
                      <div className="detalle-mueble__info__comments__comments-list__item__info">
                        <div className="detalle-mueble__info__comments__comments-list__item__author">
                          <div className="avatar">
                            <div className="avatar__inner">
                              {com.nombreUsuario.charAt(0).toUpperCase()}
                            </div>
                          </div>
                          <p>{com.nombreUsuario}</p>
                          {com.fecha && (
                            <span style={{ marginLeft: 8, color: "#888" }}>
                              ({com.fecha})
                            </span>
                          )}
                        </div>
                      </div>
                      <p className="detalle-mueble__info__comments__comments-list__item__comment">
                        {com.comentario || (
                          <span style={{ color: "#aaa" }}>Sin comentario</span>
                        )}
                      </p>
                      {com.rutasArchivos && com.rutasArchivos.length > 0 && (
                        <FileList files={com.rutasArchivos} filesVisible={3} />
                      )}
                    </div>
                  )
                )}
              </>
            ) : (
              <p
                className="detalle-mueble__info__comments__comments-list__item__comment"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  padding: "12px 0",
                  fontWeight: "700",
                }}
              >
                Todavía no hay comentarios en este mueble.
              </p>
            )}
          </div>
          {/* Formulario para agregar comentario */}
          <div className="detalle-mueble__info__comments__add-comment">
            <InputTextfield
              label="Escribe tu comentario"
              value={comentarioModalInput}
              onChange={(e) => setComentarioModalInput(e.target.value)}
              placeholder="Escribe aquí tu comentario..."
            />
            <Input
              type="file"
              label="Archivo adjunto"
              name="archivoAdjunto"
              placeholder={comentarioModalInputFileText}
              multipleFiles={true}
              onChange={handleComentarioModalFiles}
            />
            {comentarioModalFiles.length > 0 && (
              <FileList
                files={comentarioModalFiles}
                handleDelete={(file) =>
                  setComentarioModalFiles((prev) =>
                    prev.filter((f) => f.name !== file.name)
                  )
                }
              />
            )}
            <Button
              label="Enviar comentario"
              variant="filled"
              onClick={handleEnviarComentarioModal}
            />
          </div>
        </div>
      </Modal>

      <Modal
        title="Importar mobiliario especial"
        isOpen={isImportModalOpen}
        onClose={closeImportModal}
        onCancel={closeImportModal}
        onAccept={handleImport}
        primaryButtonLabel={isImporting ? "Importando..." : "Importar"}
        outlineButtonLabel="Cancelar"
        className="modal--centered"
      >
        <div className="dashboard-productos__modal">
          <form
            className="dashboard-productos__modal__content"
            onSubmit={(e) => {
              e.preventDefault();
              handleImport();
            }}
          >
            {importFile == null && (
              <Input
                type="file"
                label="Archivo Excel"
                name="archivoExcel"
                placeholder={
                  importFile ? importFile.name : "Selecciona un archivo"
                }
                onChange={handleFileChange}
              />
            )}
            <FileList
              files={importFile ? [importFile] : []}
              handleDelete={(file) => setImportFile(null)}
            />
            <InputDropdown
              options={tiendasOptions.filter((t) => tiendasAbiertas.includes(t.tienda.codTienda))}
              onSelect={handleTiendaSelect}
              placeholder="Seleccionar tienda"
              label="Tienda"
              showLabel={true}
              hasSearch={true}
              value={tiendasAbiertas.includes(selectedTienda?.tienda?.codTienda) ? selectedTienda : null}
            />
            <Input
              type="text"
              label="Nombre (opcional)"
              value={importNombre}
              onChange={(e) => setImportNombre(e.target.value)}
              placeholder="Nombre (opcional)"
            />
            <p style={{ fontSize: 12, color: "#666" }}>
              Se importará el mobiliario especial para la tienda seleccionada.
            </p>
          </form>
        </div>
      </Modal>

      {/* Popup personalizado para decisión de referencias duplicadas */}
      {isConfirmPopupOpen && (
        <div className="popup-overlay-custom" onClick={() => setIsConfirmPopupOpen(false)}>
          <div className="popup-decision-custom" onClick={(e) => e.stopPropagation()}>
            <div className="popup-decision-custom__header">
              <div className="popup-decision-custom__title">
                <PiWarning className="popup-decision-custom__icon" />
                <h3>Referencias duplicadas</h3>
              </div>
              <button
                className="popup-decision-custom__close"
                onClick={() => setIsConfirmPopupOpen(false)}
              >
                <IoMdClose />
              </button>
            </div>

            <div className="popup-decision-custom__content">
              <p className="popup-decision-custom__message">
                Se han encontrado referencias que ya estaban cargadas.
                <br /><br />
                <b>Referencias detectadas:</b>
                <ul style={{ margin: '8px 0 0 0', paddingLeft: 18, fontSize: '1rem', color: '#b26a00' }}>
                  {importConfirmData?.referenciasDuplicadas?.map((ref) => (
                    <li key={ref} style={{ marginBottom: 2 }}>{ref}</li>
                  ))}
                </ul>
                <br />¿Qué acción deseas realizar?
              </p>
            </div>

            <div className="popup-decision-custom__actions">
              <Button
                label="Cancelar"
                variant="outline"
                onClick={() => setIsConfirmPopupOpen(false)}
                fullWidth="width-100"
              />
              <Button
                label="Añadir solo nuevas"
                variant="filled"
                onClick={handleSoloNuevas}
                fullWidth="width-100"
                statusType="success"
              />
              <Button
                label="Actualizar referencias existentes y añadir nuevas"
                variant="filled"
                onClick={handleSobrescribir}
                fullWidth="width-100"
                statusType="info"
              />
              <Button
                label="Sobrescribir importación completa"
                variant="filled"
                onClick={handleSobrescribirCompleto}
                fullWidth="width-100"
                statusType="error"
              />
            </div>
          </div>
        </div>
      )}

      {/* Modal para referencias duplicadas en el Excel */}
      {duplicadasModalOpen && (
        <Modal
          title="Referencias duplicadas en el Excel"
          isOpen={duplicadasModalOpen}
          onClose={() => setDuplicadasModalOpen(false)}
          outlineButtonLabel="Cerrar"
          hideFooter={true}
        >
          <div>
            <p
              style={{
                marginBottom: 16,
                fontSize: "1.1rem",
                color: "#b26a00",
                fontWeight: 500,
                background: "#fffbe6",
                borderRadius: 6,
                padding: "12px 16px",
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              <PiWarning style={{ fontSize: 22, marginRight: 8, color: "#b26a00" }} />
              El archivo contiene referencias duplicadas. Revisa el Excel antes de volver a importarlo.
            </p>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th style={{ textAlign: "left", borderBottom: "1px solid #eee", padding: "4px 8px" }}>Referencia</th>
                  <th style={{ textAlign: "left", borderBottom: "1px solid #eee", padding: "4px 8px" }}>Repeticiones</th>
                </tr>
              </thead>
              <tbody>
                {duplicadasModalData.map((item) => (
                  <tr key={item.referencia}>
                    <td style={{ padding: "4px 8px" }}>{item.referencia}</td>
                    <td style={{ padding: "4px 8px" }}>{item.repeticiones}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Modal>
      )}

      {/* Modal de filtros */}
            <Modal
              title="Filtros"
              isOpen={isModalOpen}
              onClose={closeModal}
              onAccept={handleAcceptFilters}
              outlineButtonLabel="Limpiar"
              primaryButtonLabel={`Ver resultados (${filteredEspeciales.length})`}
              onCancel={handleCleanFilter}
            >
              <div>
                <Accordion title="Tienda">
                  <ul className="section-header__modal__section__content">
                    {tiendas.map((nombre, idx) => (
                      <Tag
                        key={idx}
                        label={nombre}
                        isSelected={filterTienda.includes(nombre)}
                        onSelect={handleSelectTienda}
                      />
                    ))}
                  </ul>
                </Accordion>
              </div>
              <Accordion title="Estado tienda">
                <Tag
                  key="estadoLabel"
                  label="Tiendas cerradas (C)"
                  isSelected={filterTiendasCerradas}
                  onSelect={handleSelectTiendasCerradas}
                />
                <Tag
                  key="estadoLabel"
                  label="Tiendas abiertas"
                  isSelected={filterTiendasAbiertas}
                  onSelect={handleSelectTiendasAbiertas}
                />
              </Accordion>
              <div className="section-header__modal__section">
                <Accordion title="Unidad">
                  <ul className="section-header__modal__section__content">
                    {unidades.map((unidad, idx) => (
                      <Tag
                        key={idx}
                        label={unidad}
                        isSelected={filterUnidad.includes(unidad)}
                        onSelect={handleSelectUnidad}
                      />
                    ))}
                  </ul>
                </Accordion>
              </div>
              <div className="section-header__modal__section">
                <Accordion title="Aprobado">
                  <ul className="section-header__modal__section__content">
                    {aprobados.map((estado, idx) => (
                      <Tag
                        key={idx}
                        label={estado}
                        isSelected={filterAprobado.includes(estado)}
                        onSelect={handleSelectAprobado}
                      />
                    ))}
                  </ul>
                </Accordion>
              </div>
            </Modal>
    </section>
  );
}
